import { css } from '@eti/styles';
import { Stack, Heading, Inline, vars } from '@etg/wings';
import { useMediaQuery } from 'usehooks-ts';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from '@eti/providers';
import { getSegment, getSeatCharacteristics } from '../utils/seatMapContentUtils';
import { SEATING_PREFERENCE_OPTIONS } from '../utils/constants';
import { seatCharacteristicsToggleButtonWrapperStyles } from '../utils/styles';
import DeckSelection from './DeckSelection';
import SeatCharacteristicsPanel from './seatCharacteristics/components/SeatCharacteristicsPanel';
import SeatingLightOrBeside from './SeatingLightOrBeside';
import SeatMapCabinLayout from './SeatMapCabinLayout';
import SeatMapTravelersDesktop from './travelerComponent/components/SeatMapTravelersDesktop';
import SeatMapTravelersMobileTabs from './travelerComponent/components/SeatMapTravelersMobileTabs';
import UnavailableSegment from './UnavailableSegment';
import SeatCharacteristicsToggleButton from './seatCharacteristics/components/SeatCharacteristicsToggleButton';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const seatMapMainContentWrapper = cabinContentHeight => css`
  background-color: ${vars.colors.page.background.primary};
  min-height: ${cabinContentHeight}px;
`;
const seatPreferencerWrapper = cabinContentHeight => css`
  min-height: ${cabinContentHeight}px;
`;
const seatCharacteristicsPanelStyles = css`
  margin-top: 16px;
`;
const seatMapMainContentOuterWrapper = css`
  border-top: 1px solid ${vars.colors.divider};
  width: 100%;
`;
const SeatMapMainContent = _ref => {
  let {
    activeSeatAssignments,
    activeSegment,
    activeTraveler,
    cabinContentHeight,
    deckOptions,
    footerRef,
    getSelected,
    headerFooterHeight,
    isRyanairInTrip,
    isSkipButtonFocused,
    onChange,
    onChangeTraveler,
    onDeckChange,
    onRemoveSeat,
    onSkipButtonFocus,
    seatTravelers,
    segments,
    selectedDeck
  } = _ref;
  const {
    t
  } = useTranslation();
  const seatingCharacteristicsHeading = t('Product.SeatMap.Characteristics.Label');
  const [expandedCharacteristicKey, setExpandedCharacteristicKey] = useState(null);
  const handleToggle = key => {
    setExpandedCharacteristicKey(prev => prev === key ? null : key);
  };
  const currentSegment = getSegment(segments, activeSegment);
  const isSeatingPreferenceAvailable = (currentSegment === null || currentSegment === void 0 ? void 0 : currentSegment.__typename) === SEATING_PREFERENCE_OPTIONS.SELL_SEATING_BESIDE || (currentSegment === null || currentSegment === void 0 ? void 0 : currentSegment.__typename) === SEATING_PREFERENCE_OPTIONS.SELL_SEATING_PREFERENCE;
  const {
    __typename,
    price
  } = currentSegment || {};
  const seatCharacteristics = getSeatCharacteristics(segments, activeSegment);
  const isDesktop = useMediaQuery(`(min-width: 1200px)`);
  const isContentAvailable = !isSeatingPreferenceAvailable && (currentSegment === null || currentSegment === void 0 ? void 0 : currentSegment.isAvailable);
  const showContentOnMobile = isContentAvailable && !isDesktop;
  const showContentOnDesktop = isContentAvailable && isDesktop;
  const isSegmentUnavailable = !isSeatingPreferenceAvailable && (!currentSegment || !currentSegment.isAvailable);
  const [travelerButtonWithRemoveLink, setTravelerButtonWithRemoveLink] = useState(undefined);
  const toggleButtonRef = useRef(null);
  const [cabinLayoutpaddingBottom, setCabinLayoutPaddingBottom] = useState(0);
  useEffect(() => {
    const calculatePaddingBottom = () => {
      var _footerRef$current, _toggleButtonRef$curr;
      const footerHeight = (footerRef === null || footerRef === void 0 || (_footerRef$current = footerRef.current) === null || _footerRef$current === void 0 ? void 0 : _footerRef$current.offsetHeight) || 0;
      const toggleHeight = ((_toggleButtonRef$curr = toggleButtonRef.current) === null || _toggleButtonRef$curr === void 0 ? void 0 : _toggleButtonRef$curr.offsetHeight) || 0;
      const toggleButtonPadding = 32;
      setCabinLayoutPaddingBottom(footerHeight + toggleHeight + toggleButtonPadding);
    };
    calculatePaddingBottom();
    window.addEventListener('resize', calculatePaddingBottom);
    return () => window.removeEventListener('resize', calculatePaddingBottom);
  }, [footerRef]);
  return /*#__PURE__*/_jsxs(Stack, {
    className: seatMapMainContentOuterWrapper,
    "data-testid": "seatMap-maincontent",
    children: [showContentOnMobile && /*#__PURE__*/_jsxs(Stack, {
      spacing: 4,
      children: [/*#__PURE__*/_jsx(SeatMapTravelersMobileTabs, {
        activeSeatAssignments: activeSeatAssignments,
        activeSegment: activeSegment,
        activeTraveler: activeTraveler,
        isRyanairInTrip: isRyanairInTrip,
        onChange: onChangeTraveler,
        onRemoveSeat: onRemoveSeat,
        seatTravelers: seatTravelers,
        setTravelerButtonWithRemoveLink: setTravelerButtonWithRemoveLink,
        travelerButtonWithRemoveLink: travelerButtonWithRemoveLink
      }), /*#__PURE__*/_jsxs(Stack, {
        children: [deckOptions.length > 1 && /*#__PURE__*/_jsx(DeckSelection, {
          onDeckChange: onDeckChange,
          options: deckOptions
        }), /*#__PURE__*/_jsx(SeatMapCabinLayout, {
          activeSegment: activeSegment,
          cabinContentHeight: cabinContentHeight,
          cabinLayoutpaddingBottom: cabinLayoutpaddingBottom,
          currentSegment: currentSegment,
          isRyanairInTrip: isRyanairInTrip,
          isSkipButtonFocused: isSkipButtonFocused,
          onChange: onChange,
          onSkipButtonFocus: onSkipButtonFocus,
          seatCharacteristics: seatCharacteristics,
          seatTravelers: seatTravelers,
          selectedDeck: selectedDeck
        })]
      }), /*#__PURE__*/_jsx(Stack, {
        className: seatCharacteristicsToggleButtonWrapperStyles(isSkipButtonFocused),
        children: /*#__PURE__*/_jsx(SeatCharacteristicsToggleButton, {
          ref: toggleButtonRef,
          seatCharacteristics: seatCharacteristics
        })
      })]
    }), /*#__PURE__*/_jsxs(Inline, {
      align: "center",
      className: seatMapMainContentWrapper(cabinContentHeight),
      noWrap: true,
      spacing: 8,
      children: [showContentOnDesktop && /*#__PURE__*/_jsxs(Inline, {
        noWrap: true,
        children: [/*#__PURE__*/_jsx(SeatMapTravelersDesktop, {
          activeSeatAssignments: activeSeatAssignments,
          activeSegment: activeSegment,
          activeTraveler: activeTraveler,
          isRyanairInTrip: isRyanairInTrip,
          onChange: onChangeTraveler,
          onRemoveSeat: onRemoveSeat,
          seatTravelers: seatTravelers,
          setTravelerButtonWithRemoveLink: setTravelerButtonWithRemoveLink,
          travelerButtonWithRemoveLink: travelerButtonWithRemoveLink
        }), /*#__PURE__*/_jsxs(Stack, {
          children: [deckOptions.length > 1 && /*#__PURE__*/_jsx(DeckSelection, {
            onDeckChange: onDeckChange,
            options: deckOptions
          }), /*#__PURE__*/_jsx(SeatMapCabinLayout, {
            activeSegment: activeSegment,
            cabinContentHeight: cabinContentHeight,
            cabinLayoutpaddingBottom: cabinLayoutpaddingBottom,
            currentSegment: currentSegment,
            headerFooterHeight: headerFooterHeight,
            isRyanairInTrip: isRyanairInTrip,
            isSkipButtonFocused: isSkipButtonFocused,
            onChange: onChange,
            onSkipButtonFocus: onSkipButtonFocus,
            seatTravelers: seatTravelers,
            selectedDeck: selectedDeck
          })]
        }), /*#__PURE__*/_jsxs(Stack, {
          "data-testid": "seatMap-characteristics",
          id: "seatMap-characteristics",
          children: [/*#__PURE__*/_jsx(Heading, {
            className: seatCharacteristicsPanelStyles,
            level: 3,
            children: seatingCharacteristicsHeading
          }), seatCharacteristics === null || seatCharacteristics === void 0 ? void 0 : seatCharacteristics.map(_ref2 => {
            let {
              characteristic,
              price: minimumPrice
            } = _ref2;
            const key = characteristic;
            return /*#__PURE__*/_jsx(SeatCharacteristicsPanel, {
              characteristic: characteristic,
              isOpen: expandedCharacteristicKey === key,
              onToggle: () => handleToggle(key),
              priceFrom: minimumPrice
            }, key);
          }), /*#__PURE__*/_jsx(SeatCharacteristicsPanel, {
            isOpen: expandedCharacteristicKey === 'unavailable',
            isUnavailable: true,
            onToggle: () => handleToggle('unavailable')
          })]
        })]
      }), /*#__PURE__*/_jsxs(Stack, {
        className: seatPreferencerWrapper(cabinContentHeight),
        children: [isSeatingPreferenceAvailable && /*#__PURE__*/_jsx(SeatingLightOrBeside, {
          activeSegment: activeSegment,
          onChange: onChange,
          price: price,
          selectedSeatPreference: getSelected(activeSegment),
          typename: __typename
        }), isSegmentUnavailable && /*#__PURE__*/_jsx(UnavailableSegment, {})]
      })]
    })]
  });
};
export default SeatMapMainContent;
//# sourceMappingURL=SeatMapMainContent.js.map